
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.8 17.6H2.2A2.2 2.2 0 010 15.4V2.2A2.2 2.2 0 012.2 0h17.6A2.2 2.2 0 0122 2.2v13.2a2.2 2.2 0 01-2.2 2.2zm-6.325-9.892a.56.56 0 01.44.213l4.895 6.523a.525.525 0 00.428.22h.023a.536.536 0 00.539-.55V2.2H2.2v11.902a.539.539 0 00.539.55h.02a.528.528 0 00.419-.209l3.378-4.334a.573.573 0 01.429-.209h.007a.55.55 0 01.422.198l1.628 1.925a.537.537 0 00.661.139.564.564 0 00.195-.161l3.137-4.081a.556.556 0 01.44-.212zM8.25 7.7a1.65 1.65 0 110-3.3 1.65 1.65 0 010 3.3z"}})])
          )
        }
      }
    